import { thumbHashToDataURL } from 'thumbhash';

const previews = new Map();

// Cockpit supplies a ThumbHash as dash-separated bytes alongside each asset.
// Decoding it needs no image request: https://github.com/evanw/thumbhash
export function getImagePreview(image) {
    const hash = image?.thumbhash;
    if (typeof hash === 'string' && /^\d{1,3}(?:-\d{1,3}){4,63}$/.test(hash)) {
        if (previews.has(hash)) return previews.get(hash);
        const bytes = hash.split('-').map(Number);
        if (bytes.every(value => value <= 255) && (bytes[3] & 7) !== 0) {
            try {
                const preview = thumbHashToDataURL(Uint8Array.from(bytes));
                previews.set(hash, preview);
                if (previews.size > 256) previews.delete(previews.keys().next().value);
                return preview;
            } catch {
                // Older or invalid assets still get a stable color placeholder.
            }
        }
    }
    const color = /^#[0-9a-f]{6}$/i.test(image?.colors?.[0]) ? image.colors[0] : '#b5d7d5';
    return `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="300" height="300"><rect width="300" height="300" fill="${color}"/></svg>`)}`;
}
